import { api } from "@/shared/api";
import type { User } from "../model/types";

export async function fetchCurrentUser(): Promise<User | null> {
  try {
    const res = await api.get<User>("/api/me", { timeout: 3000 });
    return res.data;
  } catch (err: any) {
    // Если сервер не ответил, соединение сброшено, таймаут или 401:
    // считаем пользователя неавторизованным
    console.warn("Пользователь не авторизован или сервер не ответил:", err?.message || err);
    return null;
  }
}

export async function logoutUser(): Promise<void> {
  await api.post("/auth/logout");
}

export async function fetchAuthCallback(code: string): Promise<{ user: User }> {
  const res = await api.get<{ user: User }>(`/auth/yandex/callback?code=${encodeURIComponent(code)}`);
  return res.data;
}
